/* eslint-disable no-underscore-dangle */
const favorites = []
const MAX_FAVORITES = 6

const loadInitialState = () => {
  try {
    const stored = localStorage.getItem('userFavorites')
    if (stored) {
      const parsedFavorites = JSON.parse(stored)

      // Empty the array and push all items
      favorites.length = 0
      parsedFavorites.forEach(item => favorites.push(item))
    }
  } catch (error) {
    console.error('Error loading favorites:', error)
  }
}

const saveToLocalStorage = () => {
  localStorage.setItem('userFavorites', JSON.stringify(favorites))
}

loadInitialState()

const FavoriteService = {

  getFavorites() {
    return [...favorites]
  },

  /**
   * Record a menu interaction and update favorites if needed
   * @param {Object} menuItem - Menu item with name, route, and icon properties
   */
  recordInteraction(menuItem) {
    if (!menuItem || !menuItem.name || !menuItem.route) return

    // Check if this menu item already exists in favorites
    const existingIndex = favorites.findIndex(
      item => item.route === menuItem.route,
    )

    if (existingIndex >= 0) {
      // Item exists, increment count and update timestamp
      const existing = favorites[existingIndex]
      existing.count = (existing.count || 0) + 1
      existing.lastAccessed = Date.now()

      // Re-sort to reflect updated ranking
      this._sortFavorites()
    } else {
      const newFavorite = {
        name: menuItem.name,
        route: menuItem.route,
        icon: menuItem.icon || 'FileIcon',
        count: 1,
        lastAccessed: Date.now(),
      }

      favorites.push(newFavorite)

      this._sortFavorites()
      if (favorites.length > MAX_FAVORITES) {
        favorites.splice(MAX_FAVORITES)
      }
    }

    saveToLocalStorage()
  },

  removeFavorite(routeName) {
    const index = favorites.findIndex(item => item.route === routeName)
    if (index >= 0) {
      favorites.splice(index, 1)
      saveToLocalStorage()
    }
  },

  clearFavorites() {
    favorites.length = 0
    saveToLocalStorage()
  },

  /**
   * Sort favorites by count (primary) and lastAccessed (secondary)
   * @private
   */
  _sortFavorites() {
    favorites.sort((a, b) => {
      // Primary sort by count (descending)
      if (b.count !== a.count) {
        return b.count - a.count
      }
      return b.lastAccessed - a.lastAccessed
    })
  },
}

export default FavoriteService
